import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

/**
 * Shared markdown renderer used by the test client and the review pages.
 * Supports GitHub-flavoured markdown and honours single line breaks (\n),
 * with consistent styling for paragraphs, links and lists.
 */
const markdownComponents = {
  p: ({ children }) => (
    <p style={{ marginTop: 0, marginBottom: '0.5rem' }}>{children}</p>
  ),
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'var(--ids-color-primary, #0065bd)', textDecoration: 'underline' }}
    >
      {children}
    </a>
  ),
  ol: ({ children }) => (
    <ol style={{ marginTop: 0, marginBottom: '0.5rem', paddingLeft: '1.25rem' }}>{children}</ol>
  ),
  ul: ({ children }) => (
    <ul style={{ marginTop: 0, marginBottom: '0.5rem', paddingLeft: '1.25rem' }}>{children}</ul>
  ),
  li: ({ children }) => (
    <li style={{ marginBottom: '0.25rem' }}>{children}</li>
  ),
  strong: ({ children }) => (
    <strong style={{ fontWeight: 600 }}>{children}</strong>
  ),
};

const MarkdownContent = ({ children, style }) => (
  <div style={{ margin: 0, ...style }}>
    <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]} components={markdownComponents}>
      {children || ''}
    </ReactMarkdown>
  </div>
);

export default MarkdownContent;
